import { FlexWrapper, Text } from '@intigral/shared';
import withPresetWidth from '@intigral/shared/components/hocs/withPresetWidth/withPresetWidth';
import { __ } from '../../../../translations';
import { Badges, Quests, ScoreCard } from '../elements';

const GamificationView = ({ badgeProps, scoreCardProps, questProps, children }) => {
    const FlexWidth = withPresetWidth(FlexWrapper);
    return (
        <div className="container">
            <Text as="h2" variant="h2" margin="4x" fontWeight="medium" color="white">
                {__('play_rewards')}
            </Text>
            <FlexWidth flexDirection="column" gap="3x" presetWidth="medium" paddingBottom="6x">
                <Badges badgeProps={badgeProps} />
                <ScoreCard scoreCardProps={scoreCardProps} />
                <Quests questProps={questProps} />
            </FlexWidth>
            {children}
        </div>
    );
};

export default GamificationView;
